import { render, staticRenderFns } from "./admin-agent-details.vue?vue&type=template&id=8f926314&scoped=true&"
import script from "./admin-agent-details.vue?vue&type=script&lang=js&"
export * from "./admin-agent-details.vue?vue&type=script&lang=js&"
import style0 from "./admin-agent-details.vue?vue&type=style&index=0&id=8f926314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f926314",
  null
  
)

export default component.exports